import React from 'react';
import MuiDialog from '@mui/material/Dialog';

const Dialog = (props) => <MuiDialog {...props} />;

export default Dialog;
